/**
 * @sauti-pbx/voice-sdk — browser SDK for placing and receiving web calls on the
 * SautiPBX voice platform.
 *
 * Script-tag users get everything under the `VoiceSDK` global (e.g.
 * `new VoiceSDK.Phone()`). Bundler users import named exports.
 */
export { Phone } from './phone';
export type { PhoneEvents } from './phone';
export { Call } from './call';
export type { CallEvents } from './call';
export { decodeToken, isExpired } from './token';
export { DEFAULT_ICE_SERVERS } from './ice';
// A one-line human summary of a `failed`/`ended` FailureReason, e.g.
// `"402 Insufficient balance · cause=Rejected"` — handy for surfacing exactly why
// a call was refused (insufficient funds, a cap, offline callee) in your UI.
export { describeFailure } from './util';
export type {
  PhoneOptions,
  AuthCredentials,
  CallOptions,
  TokenClaims,
  MediaDevices,
  FailureReason,
  LogLevel,
  LogSink,
} from './types';
